import type { ReactNode } from 'react';

/**
 * Icônes SVG (stroke, style Lucide). Un produit pro n'utilise pas d'emoji comme icônes :
 * trait fin régulier, `currentColor` (l'icône hérite la couleur du bouton), grille 24.
 * Taille via `size` (défaut 22). Décoratives : aria-hidden, le bouton porte le libellé.
 */
function Svg({ size = 22, children }: { size?: number | undefined; children: ReactNode }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {children}
    </svg>
  );
}

type P = { size?: number };

export const IconeCamera = ({ size }: P) => (
  <Svg size={size}>
    <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3Z" />
    <circle cx="12" cy="13" r="3" />
  </Svg>
);

export const IconeImage = ({ size }: P) => (
  <Svg size={size}>
    <rect x="3" y="3" width="18" height="18" rx="2.5" />
    <circle cx="8.5" cy="8.5" r="1.8" />
    <path d="m21 15-3.1-3.1a2 2 0 0 0-2.8 0L6 21" />
  </Svg>
);

export const IconeMicro = ({ size }: P) => (
  <Svg size={size}>
    <rect x="9" y="2" width="6" height="12" rx="3" />
    <path d="M19 11v1a7 7 0 0 1-14 0v-1" />
    <line x1="12" y1="19" x2="12" y2="22" />
  </Svg>
);

export const IconeStop = ({ size }: P) => (
  <Svg size={size}>
    <rect x="6" y="6" width="12" height="12" rx="2.5" />
  </Svg>
);

export const IconeEnvoi = ({ size }: P) => (
  <Svg size={size}>
    <path d="M12 20V5" />
    <path d="m5.5 11.5 6.5-6.5 6.5 6.5" />
  </Svg>
);

export const IconeInstaller = ({ size }: P) => (
  <Svg size={size}>
    <path d="M12 3v12" />
    <path d="m7 11 5 5 5-5" />
    <path d="M5 21h14" />
  </Svg>
);

export const IconeCompte = ({ size }: P) => (
  <Svg size={size}>
    <circle cx="12" cy="8" r="3.5" />
    <path d="M5.5 20a6.5 6.5 0 0 1 13 0" />
  </Svg>
);

export const IconeContacts = ({ size }: P) => (
  <Svg size={size}>
    <path d="M16 20v-1.5a3.5 3.5 0 0 0-3.5-3.5h-4A3.5 3.5 0 0 0 5 18.5V20" />
    <circle cx="10.5" cy="8" r="3.5" />
    <path d="M18.5 13.5a3.5 3.5 0 0 0 0-6.8" />
    <path d="M21 20v-1.5a3.5 3.5 0 0 0-2.5-3.35" />
  </Svg>
);

export const IconeCloche = ({ size }: P) => (
  <Svg size={size}>
    <path d="M6 9a6 6 0 0 1 12 0c0 5.5 2.2 7 2.2 7H3.8S6 14.5 6 9Z" />
    <path d="M10.2 20a2 2 0 0 0 3.6 0" />
  </Svg>
);

export const IconeClocheOff = ({ size }: P) => (
  <Svg size={size}>
    <path d="M9 4.2A6 6 0 0 1 18 9c0 2.2.4 3.8.9 5" />
    <path d="M5.6 8.8A6 6 0 0 1 6 9c0 5.5-2.2 7-2.2 7h13" />
    <path d="M10.2 20a2 2 0 0 0 3.6 0" />
    <line x1="3" y1="3" x2="21" y2="21" />
  </Svg>
);
